import { EditTabsAndNavResponse, TabType } from './types';
import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type GetEditTabsAndNavOptions = CommonRequestOptions & {
   stepid?: number;
};

export async function getEditTabsAndNav(
   active: TabType,
   guideid: number,
   { stepid, ...common }: GetEditTabsAndNavOptions = {}
): Promise<EditTabsAndNavResponse> {
   return makeRequest('get', `guides/${guideid}/editTabsAndNav/${active}`, {
      ...common,
      query: { stepid },
   });
}
